
<template>
  <v-container>
      <div v-if="profile.platforms && profile.platforms.length == 0">
        <info-block>{{$t('onlineIds.none-notice')}}</info-block>
      </div>
      <v-row v-for="platform in platforms" :key="platform.platform_code + '_' + platform.game_code" class="align-center">
        <v-col cols="8">
          <user-online-id large :platformCode="platform.platform_code" :onlineId="platform.platform_nickname" :gameCode="platform.game_code"/>
        </v-col>
        <v-col cols="4" class="text-right">
          <v-btn
            @click="deleteUserPlatform(platform.platform_code, platform.game_code, platform.platform_nickname)"
            :disabled="loading"
            class="secondary warning"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <div v-if="profile">
        <form @submit="submitPlatformForm" action="/">
          <v-row class="align-center">
            <v-col cols="12" class="pb-0">
              <span class="overline">{{$t('profile.add-online-id')}}</span>
            </v-col>
            <v-col cols="12" sm="4">
              <platform-select
                v-model="newPlatform"
                :disabled="loading"
              ></platform-select>
            </v-col>
            <v-col v-if="newPlatform" cols="8" sm="6">
              <game-select
                v-model="newPlatformGame"
                :label="$t('profile.online-id-for-game-optional')"
                :placeholder="$t('profile.online-id-as-platform-standard-placeholder')"
                :disabled="loading"
              />
            </v-col>
            <v-col v-if="newPlatform" cols="8" sm="6">
              <v-text-field
                v-model="newPlatformNickname"
                :label="$t('profile.online-id')"
                type="text"
                placeholder
                :disabled="loading"
                autocomplete="off"
                :rules="validationRules.required"
              ></v-text-field>
            </v-col>
            <v-col v-if="newPlatform" cols="4" sm="2" class="text-right">
              <v-btn type="submit" class="primary" :disabled="loading">
                <v-icon>mdi-content-save</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </form>
      </div>
  </v-container>
</template>

<script>
import PlatformSelect from "@/widgets/PlatformSelect";
import { EVENT_REFRESH_DATA } from "@/plugins/eventbus";
import profileMixin from "@/mixins/profileMixin";
import envMixin  from "@/mixins/envMixin";
import platformMixins from "@/mixins/platformMixins.js";
import UserOnlineId from "@/widgets/UserOnlineId";
import { MUTATION_RAISE_NOTIFICATION, ACTION_LOAD_PROFILE, MUTATION_PROFILE_LOADED } from "@/plugins/store";
import InfoBlock from './InfoBlock.vue';
import GameSelect from './GameSelect.vue';

export default {
  name: "OnlineIds",
  mixins: [platformMixins, profileMixin, envMixin],
  props: {
    showHeader: {
      type: Boolean,
      default: true,
    },
  },
  components: {PlatformSelect, UserOnlineId, InfoBlock, GameSelect},

  data: function() {
    return {
      loading: false,
      newPlatform: undefined,
      newPlatformGame: undefined,
      newPlatformNickname: undefined,
      validationRules: {
          required: [v => !!v || this.$t('common.mandatory-field')],
      },
    }
  },
  computed: {
    profile: function() {
      return this.$store.state.profile;
    },
    platforms: function() {
      return this.profile ? this.profile.platforms : [];
    },
  },
  mounted() {
    this.refresh();
    this.$eventBus.$on(EVENT_REFRESH_DATA, this.refresh);
  },
  beforeDestroy() {
    this.$eventBus.$off(EVENT_REFRESH_DATA, this.refresh);
  },
  methods: {
    refresh() {
      this.loading = true;
      this.$store.dispatch(ACTION_LOAD_PROFILE).finally(() => {
        this.loading = false;
      });
    },
    submitPlatformForm(e) {
      e.preventDefault();
      this.loading = true;
      this.$api
        .addUserPlatform(
          {
            platform_code: this.newPlatform,
            game: this.newPlatformGame,
            platform_nickname: this.newPlatformNickname,
          })
        .then(response => {
          var id = this.newPlatformNickname
          this.loading = false;
          this.newPlatform = undefined;
          this.newPlatformGame = undefined
          this.newPlatformNickname = undefined;
          this.$store.commit(MUTATION_RAISE_NOTIFICATION, {
            type: "success",
            message: this.$t('onlineIds.successfully-added-online-id', {id: id})
          });
          this.$store.commit(MUTATION_PROFILE_LOADED, response.data);
        })
        .catch(error => {
          this.loading = false;
          this.$common.onError(error)
        });
      return false;
    },
    deleteUserPlatform(platformCode, gameCode, id) {
      this.loading = true
      this.$api
        .deleteUserPlatform(platformCode, {game: gameCode})
        .then(response => {
          this.$store.commit(MUTATION_PROFILE_LOADED, response.data);
          this.loading = false;
          this.$store.commit(MUTATION_RAISE_NOTIFICATION, {
            type: "success",
            message: this.$t('onlineIds.successfully-deleted-online-id', {id: id})
          });
        })
        .catch(error => {
          this.loading = false;
          this.$common.onError(error)
        });
    },
  },
};
</script>
